"use client";

import dynamic from "next/dynamic";

export const NativeBridgeProvider = dynamic(
  () => import("./nativeBridgeContext").then((mod) => mod.NativeBridgeProvider),
  { ssr: false }
);
